// src/i18n/index.ts
// ChessMaestro.ai - i18n Configuration

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './locales';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('chessmaestro-language') || 'it',
    fallbackLng: 'it',
    supportedLngs: ['it', 'en', 'es', 'de', 'fr', 'ru'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;